export default __webpack_public_path__ + "static/media/element_19.cf468d0e.jpg";